<template>
<div>
    <Nav isActive="home"/>
    <div class="pageWD mT20 shadowBox  minHeight">
      <div class="nlist"> 
        <el-row>
            <el-col :span="6" class="leftbar"> 
              <div class="title">帮助列表</div> 
              <div class="item" :class="[activeIndex==index?'active':'']" v-for="(item,index) in helpList" :key="index" @click="tapClick(index,item)">
                <div class="c3 f16">{{item.giTitle}}</div>
              </div>
            </el-col>
            <el-col :span="18" v-if="detail" class="detail">   
                <div class="f18 c3 name">{{detail.giTitle}}</div>              
                <div class="dep f18 c6" v-html="detail.giContext"></div>  
            </el-col>
        </el-row>        
      </div>  
    </div> <div style="height:20px"></div>   
</div>
</template>
<script>
import Nav from "../../../components/Nav.vue";
import {getHelpList, getHelpDetail } from '@/api/api'
export default {
  components: { Nav },
  data() {
    return {
      helpList:[],
      detail:null,
      activeIndex:this.$route.query.index,
      giId:this.$route.query.id
    }
  },
  created() {
    this.getHelpList()
  },
  watch: {
    $route(to, from) {
      console.log(to)
      console.log(from)
      this.activeIndex = to.query.index
      this.giId = to.query.id
      this.getDetail(this.giId)
    //  this.$router.go(0)
      // 对路由变化作出响应...
      //可以使用$router.go(0)进行刷新,（补充，该方法在ios手机上无效）
      //可以改用window.location.reload()
    }
  },
  methods: { 
    tapClick(index,item){   
      this.activeIndex = index
      this.getDetail(item.giId)
    },   
    getHelpList() {
      var that = this
      let data = {
       
      };
      getHelpList(data)
        .then(res => {         
          that.helpList = res.body.result
          that.getDetail(that.giId)  
        })
        .catch(err => {});
    },
    getDetail(giId){
      let data = {
        guideId: giId
      };
      var that = this
      getHelpDetail(data)
        .then(res => {         
          that.detail = res.body.result
        })
        .catch(err => {});
    } 
  }
}
</script>

<style scoped>
  .nlist .item{
    cursor: pointer;
    padding:24px 24px 24px 16px;
     border-left:8px solid #fff;
  }
  .nlist .item:hover{
    background: #e4f0fe;
    border-left:8px solid #e4f0fe;
  }
  .nlist .active{
    border-left:8px solid #4b9afb;
    box-shadow: 0px 1px 10px 0px rgba(0,0,0,0.15); 
  }
  .nlist .active .f16{
    color: #4B9AFB;
  }
  .nlist .title{
    width: 100%;
    height: 91px;
    line-height:91px;
    font-size: 18px;
    padding-left:24px;
    background: #ffffff;
  }
  .nlist .detail{
    padding:24px
  }
  .nlist .name{
    padding:15px 0 14px 0
  }
  .nlist .detail .dep{
    line-height: 27px;
    padding-top:20px;
  }
</style>


// WEBPACK FOOTER //
// src/views/home/HelpCenter/index.vue